var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-timeline-item',{staticClass:"timeline-item",attrs:{"color":"grey","small":_vm.small}},[_c('v-layout',{class:_vm.isSelected ? 'item-selected' : 'pointer item',attrs:{"justify-space-between":""},on:{"click":_vm.select}},[_c('content-type-icon',{attrs:{"height":"40px","type":_vm.type}}),_vm._v(" "+_vm._s(_vm.title)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }